module.exports = __webpack_public_path__ + "img/1.6faf36b8.png";